import api from "./axios";

const BASE_URL = "/api/v1/universities";

export const fetchUniversities = async (page = 0, size = 100, query = "") => {
  const params = { page, size, search: query };
  const response = await api.get(BASE_URL, { params });
  return response.data; // returns paged response
};

export async function createUniversity(data) {
  const response = await api.post(BASE_URL, data);
  return response.data;
}

export async function updateUniversity(id, data) {
  const response = await api.put(`${BASE_URL}/${id}`, data);
  return response.data;
}

export async function deleteUniversity(id) {
  await api.delete(`${BASE_URL}/${id}`);
}
